var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrnMapHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "23px",
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Help") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BRN---Mapping-the-Network---Instructions",
    transform: "translate(-1374.000000, -124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1374.166667, 124.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7300702,0.315033216 C20.4272052,-1.57900609 28.6407558,5.28225412 26.4852537,15.1242441 C24.7603787,23 14.4427228,24.8817959 7.06502746,21.1603205 C-4.62686891,15.2626652 -0.931024323,3.07233321 11.7300702,0.315033216 Z",
    id: "Path-3-Copy-2",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "?",
    transform: "translate(8.921833, 5.964000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.128,8.33 L4.726,8.33 C4.862,6.63 8.653,6.256 8.704,3.366 C8.738,1.224 7.174,0 4.811,0 C2.567,0 1.054,1.326 0,3.162 L2.159,4.573 C2.703,3.468 3.366,2.72 4.301,2.72 C4.913,2.72 5.355,3.06 5.355,3.672 C5.355,4.947 3.23,5.253 3.128,7.99 L3.128,8.33 Z M2.567,12.036 L5.576,12.036 L5.576,9.129 L2.567,9.129 L2.567,12.036 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrnMapHelpIcon);
export default __webpack_public_path__ + "static/media/BRN-Map-Help-Icon.36cac7f1d8409d019e1c9fea4607ef90.svg";
export { ForwardRef as ReactComponent };